
import React, { KeyboardEvent } from 'react';

import './SelectionTextBox.css';

interface TextBoxSelectionProps {
    value: number;
    onremove: (value: number) => void;
}

class TextBoxSelection extends React.Component<TextBoxSelectionProps> {
    constructor(props: TextBoxSelectionProps) {
        super(props);
    }

    render() {
        return (
            <li>
                {this.props['value']}
                <div onClick={event => {event.stopPropagation(); this.props['onremove'](this.props['value'])}}>&times;</div>
            </li>
        );
    }
}

interface SelectionTextBoxSuggestionsProps {
    width: number;
    suggestions: {possibilities: any, autocomplete: string | null};
    builder: (suggestions: {possibilities: any, autocomplete: string | null}, width: number) => JSX.Element;
}

class SelectionTextBoxSuggestions extends React.Component<SelectionTextBoxSuggestionsProps> {
    constructor(props: SelectionTextBoxSuggestionsProps) {
        super(props);
    }

    render() {
        return this.props['builder'](this.props['suggestions'], this.props['width']);
    }
}

interface SelectionTextBoxProps {
    content: any[];
    placeholder: string;
    onselectionupdate: (content: any[]) => void;
    parser: (str: string) => any;
    width: number;
    prompt?: string;
    suggestion_callback?: (txt: string) => {possibilities: any, autocomplete: string | null};
    suggestion_builder?: (suggestions: {possibilities: any, autocomplete: string | null}, width: number) => JSX.Element;
    max_selections?: number;
    display_args?: any[];
}

interface SelectionTextBoxState {
    suggestions: {possibilities: any, autocomplete: string | null} | null;
    can_press_enter: boolean;
}

class SelectionTextBox extends React.Component<SelectionTextBoxProps, SelectionTextBoxState> {
    max_selections: number;
    text_box: HTMLInputElement | null;

    constructor(props: SelectionTextBoxProps) {
        super(props);

        this.state = {
            'suggestions': null,
            'can_press_enter': false
        }

        this.handleInput = this.handleInput.bind(this);
        this.removeSelection = this.removeSelection.bind(this);
        this.max_selections = this.props['max_selections'] !== undefined ? this.props['max_selections'] : 1;
        this.text_box = null;
    }

    handleInput() {
        const text_box_parsed = this.text_box === null ? null : this.props['parser'](this.text_box.value);

        this._updateSuggestions();
        this.setState({'can_press_enter': (text_box_parsed !== null)});
    }

    removeSelection(sel: any) {
        let selections = this.props['content']
        selections = selections.filter(s => {
            if (typeof s === 'object') {
                const args = this.props['display_args'] === undefined ? [] : this.props['display_args'];
                s = s.display(...args);
            }
            return s !== sel;
        });

        this.props['onselectionupdate'](selections);
    }

    onfocus() {
        if (this.text_box === null) return;

        this.text_box.focus();
        this._updateSuggestions();
    }

    onblur() {
        this.setState({'suggestions': null});
    }

    onkey(event: React.KeyboardEvent) {
        if (this.text_box === null) return;

        if (this.props['suggestion_callback'] !== undefined && event.keyCode == 9) {
            event.nativeEvent.preventDefault();
            if (this.state['suggestions'] !== null && this.state['suggestions']['autocomplete'] !== null) {
                this.text_box.value = this.state['suggestions']['autocomplete'];

                this._updateSuggestions();
            }
        }
        else if (event.keyCode == 13) {
            const parsed_val = this.props['parser'](this.text_box.value);

            if (parsed_val !== null) {
                let selections = this.props['content'].concat([parsed_val]);
                if (selections.length > this.max_selections) {
                    selections.shift();
                }

                this.text_box.value = '';

                this._updateSuggestions();
                this.setState({'can_press_enter': false});
                this.props['onselectionupdate'](selections);
            }
        }
        event.nativeEvent.stopPropagation();
    }

    _updateSuggestions() {
        if (this.props['suggestion_callback'] !== undefined && this.text_box !== null) {
            const suggestions = this.props['suggestion_callback'](this.text_box.value);
            this.setState({'suggestions': suggestions});
        }
    }

    render() {
        let selection_list = (
            <ul>
                {this.props['content'].map(s => {
                    let display = s;
                    if (typeof display === 'object') {
                        const args = this.props['display_args'] === undefined ? [] : this.props['display_args'];
                        display = display.display(...args);
                    }
                    return <TextBoxSelection key={display} value={display} onremove={this.removeSelection}/>;
                })}
            </ul>
        );

        if (this.props['content'].length == 0) {
            selection_list = (
                <ul>
                    {<li className='dummy'>.</li>}
                </ul>
            );
        }

        const width = this.props['width'] !== undefined ? this.props['width'] : 500;

        let suggestions_box = <span></span>;
        let cls = "selectiontextbox";
        if (this.props['suggestion_builder'] !== undefined && this.state['suggestions'] !== null) {
            suggestions_box = <SelectionTextBoxSuggestions
                                suggestions={this.state['suggestions']}
                                builder={this.props['suggestion_builder']}
                                width={width-2}
                              />;
        }

        let enter_prompt = <span></span>;
        if (this.state['can_press_enter']) {
            enter_prompt = <span>Press ENTER to apply</span>;
        }
        else {
            const prompt = this.props['prompt'] === undefined ? "" : this.props['prompt'];
            enter_prompt = <span>{prompt}</span>
        }

        return (
            <div className={cls} onClick={this.onfocus.bind(this)} style={{'width': width + 'px'}}>
                {selection_list}
                <input
                    ref={el => this.text_box = el}
                    type="text"
                    placeholder={this.props['placeholder']}
                    onInput={this.handleInput}
                    onBlur={this.onblur.bind(this)}
                    onKeyDown={this.onkey.bind(this)}
                />
                {enter_prompt}
                {suggestions_box}
            </div>
        );
    }
}

export default SelectionTextBox;